import React from 'react'

const TataPuppet = (props) => {
	return (
		<img className="fc-tata-puppet" src={"/img/tatino_" + props.type + ".svg"}/>
	)
}

export default TataPuppet